module.exports = __webpack_public_path__ + "static/media/10_4.3b0df34c.jpg";